<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><a id="page_4"><em>dedication</em> <strong>*</strong> <em>to diana b. torrey, for teaching me how to make even messy food look pretty — you are missed.</em></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?63109d22